import { render, staticRenderFns } from "./SpotsList.vue?vue&type=template&id=4ec8a48c"
import script from "./SpotsList.vue?vue&type=script&lang=js"
export * from "./SpotsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports